import React, { useState } from 'react';
import {
  Card,
  Button,
  Label,
  Input,
  Row,
  Col,
  CardTitle,
  Form,
} from 'reactstrap';
import { Formik } from 'formik';
import { handleConfirmCancel, handleError } from '@components/toast';
import * as yup from 'yup';
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { DeleteCreditsSettings, CreateCreditsSettings, UpdateCreditsSettings } from '../../../../graphql/Mutation';
// import {  } from '@apollo/client';
import { ListCreditsSettings } from '../../../../graphql/Query';
import '@styles/react/libs/editor/editor.scss';
import {
  useQuery,
  useMutation
} from '@apollo/client';
import SidebarEarnCredit from './SidebarEarnCredit';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);
// Validación con yup
const ValidationSchema = yup.object().shape({
  activity: yup.string().required('Este campo es requerido'),
  amount: yup.number().required('Este campo es requerido'),
  benefitType: yup.string().required('Este campo es requerido'),
  toShare: yup.string().required('Este campo es requerido'),
  description: yup.string(),
});

// Opciones para los selectores
const activityes = [
  {
    label: 'Completar episodios',
    value: 'EPOSODES'
  },
  {
    label: 'Completar caminos',
    value: 'ROADS'
  },
  {
    label: 'Completar activityes',
    value: 'ACTIVITIES'
  },
  {
    label: 'Racha de días en la app',
    value: 'APP_STREAK'
  },
  {
    label: 'Racha de días premium',
    value: 'PREMIUM_STREAK'
  },
  {
    label: 'Invitación a un plan',
    value: 'PLAN_INTITATION'
  },
  {
    label: 'Invitación de amigos',
    value: 'FRIEND_INVITATION'
  }
];


const tiposBeneficio = [
  {
    label: 'Días Premium',
    value: 'PREMIUM_DAYS'
  },
  {
    label: 'Beneficio Externo',
    value: 'EXTERNAL'
  }
];

const compartirOpciones = [
  {
    label: 'Sí',
    value: 'YES'
  },
  {
    label: 'No',
    value: 'NO'
  }
];

const EditorComponent = ({ content, handleOnChange }) => {
  const blocksFromHtml = convertFromHTML(content || '');
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap
      )
    )
  );

  const handleChanges = (newEditorState) => {
    setEditorState(newEditorState);
    const draft = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));

    // Actualizar el campo de Formik con el contenido HTML
    handleOnChange('description', draft);
  };

  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={handleChanges}
      wrapperClassName="demo-wrapper"
      editorClassName="demo-editor"
    />
  );
};


export const EarnCreditSettingsModule = ({ }) => {
  const { data, loading, refetch } = useQuery(ListCreditsSettings, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first'
  });
  const Credits = data?.listCreditsSettings;

  const [deleteCreditsSettings] = useMutation(DeleteCreditsSettings);
  const [edit] = useState(false);

  // Usa un solo useMutation
  const [mutate] = useMutation(edit ? UpdateCreditsSettings : CreateCreditsSettings);
  const [openForm, setOpenForm] = useState(false);
  const [open, setOpen] = useState(false);
  const [Credit, setCredit] = useState(null);

  const [initialValues] = useState({
    activity: '',
    amount: 1,
    benefitType: '',
    toShare: '',
    description: '',
    premiumDays: 1,
    benefitName: ''
  });

  // Manejar el envío del formulario
  const onSubmit = async (formData, { resetForm }) => {

    try {

      await mutate({
        variables: {
          input: formData
        }
      });
      setOpenForm(!openForm);
      refetch();
      MySwal.fire({
        icon: 'success',
        title: 'Credito creado con exito',
        text: '',
        customClass: {
          confirmButton: 'btn btn-success'
        }
      });
  
      resetForm();
    } catch (e) {
      handleError(e);
      throw e;
    }

  };

  const handleDelete = async (d) => {
    handleConfirmCancel('delete', false, async () => {
      try {
        await deleteCreditsSettings({ variables: { id: d._id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <Card body>
      <CardTitle tag="h5" className="row m-0 p-1">
        <div className='col p-0'>
          Ganar Créditos
        </div>
          <div className='btn btn-primary col-2' onClick={() => { setOpenForm(!openForm); }}>
          { openForm ? 'Lista Créditos' : 'Crear Créditos' }
          </div>
      </CardTitle>
      <Row className="m-0">
        {
          openForm ? (<Col md={12}>
            <Formik
              initialValues={initialValues}
              validationSchema={ValidationSchema}
              onSubmit={onSubmit}
              className={'col-12'}
            >
              {({ values, handleChange, handleBlur, handleSubmit, setFieldValue, errors }) => (
                <Form onSubmit={handleSubmit}>
                  <Row style={{ marginBottom: 20 }}>
                    <Col>
                      <Label for="activity">Actividad</Label>
                      <Input
                        type="select"
                        name="activity"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.activity}
                        invalid={errors.activity && true}
                      >
                        <option value="">Selecciona una activity</option>
                        {activityes.map((activity, index) => (
                          <option key={index} value={activity.value}>
                            {activity.label}
                          </option>
                        ))}
                      </Input>
                    </Col>
                    <Col>
                      <Label for="description">Titulo</Label>
                      <Input
                        name="title"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.title}
                        invalid={errors.title && true}
                      />
                    </Col>
                    <Col>
                      <Label for="description"> SubTitulo</Label>
                      <Input
                        name="subTitle"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.subTitle}
                        invalid={errors.subTitle && true}
                      />
                    </Col>
                    <Col>
                      <Label for="cantidad">Cantidad</Label>
                      <Input
                        type="number"
                        name="amount"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.amount}
                        invalid={errors.amount && true}
                        min={1}
                      />
                    </Col>

                    <Col>
                      <Label for="benefitType">Tipo de Beneficio</Label>
                      <Input
                        type="select"
                        name="benefitType"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.benefitType}
                        invalid={errors.benefitType && true}
                      >
                        <option value="">Selecciona un beneficio</option>
                        {tiposBeneficio.map((beneficio, index) => (
                          <option key={index} value={beneficio.value}>
                            {beneficio.label}
                          </option>
                        ))}
                      </Input>
                    </Col>

                    <Col>
                      <Label for="toShare">Para Compartir</Label>
                      <Input
                        type="select"
                        name="toShare"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.toShare}
                        invalid={errors.toShare && true}
                      >
                        <option value="">Selecciona opción</option>
                        {compartirOpciones.map((opcion, index) => (
                          <option key={index} value={opcion.value}>
                            {opcion.label}
                          </option>
                        ))}
                      </Input>
                    </Col>
                  </Row>
                  <Row >
                    {/* Condicional para mostrar campos adicionales */}
                    {values.benefitType === 'EXTERNAL' && (<>
                      <Col md={12} style={{ marginBottom: 20 }}>
                        <Label for="description">Descripción</Label>
                        <EditorComponent
                          content={values.description}
                          handleOnChange={(field, value) => setFieldValue(field, value)}
                        />
                      </Col>
                      <Col md={12} style={{ marginBottom: 20 }}>
                        <Label for="benefitName">Nombre del Beneficio</Label>
                        <Input
                          name="benefitName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.benefitName}
                          invalid={errors.benefitName && true}
                        />
                      </Col>
                    </>
                    )}

                    {values.benefitType === 'PREMIUM_DAYS' && (
                      <>
                        <Col md={12} style={{ marginBottom: 20 }}>
                          <Label for="description">Descripción</Label>
                          <Input
                            name="description"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            invalid={errors.description && true}
                          />
                        </Col>
                        <Col md={6}>
                          <Label for="premiumDays">Días Premium</Label>
                          <Input
                            type="number"
                            name="premiumDays"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.premiumDays}
                            invalid={errors.premiumDays && true}
                            min={1}
                          />
                        </Col>
                      </>
                    )}
                    <Col className="d-flex align-items-center mt-2">
                      <Button type="submit" color="primary">
                        Crear Nueva
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>) : (
            <Col md={12}>


              {/* Tabla de Resultados */}

              {
                !loading && (
                  <div>
                    {Credits.map((entry) => (
                      <div key={entry.id} className='row' style={{ border: '1px solid #d0d2d6', borderRadius: '10px', padding: '10px 0px', paddingRight: '60px', position: 'relative', marginBottom: '20px' }}>
                        <div className='col'><div style={{ fontWeight: 'bold' }}>Actividad</div> {activityes.find(e => e.value === entry.activity)?.label}</div>
                        <div className='col'><div style={{ fontWeight: 'bold' }}>Cantidad</div> {entry.amount}</div>
                        <div className='col'><div style={{ fontWeight: 'bold' }}>Tipo de Beneficio</div> {tiposBeneficio.find(e => e.value === entry.benefitType)?.label}</div>
                        <div className='col'><div style={{ fontWeight: 'bold' }}>Para Compartir</div> {compartirOpciones.find(e => e.value === entry.toShare)?.label}</div>
                        <div style={{ position: 'absolute', right: '10px', width: '60px', padding: 0 }}>
                          <div style={{ width: '30px', float: 'left', cursor: 'pointer' }} onClick={() => { handleDelete(entry); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                              <g id="Grupo_490" data-name="Grupo 490" transform="translate(-1802 -191)">
                                <circle id="Elipse_64" data-name="Elipse 64" cx={12} cy={12} r={12} transform="translate(1802 191)" fill="#ff5353" />
                                <path id="delete" d="M.536,8.7V2.168H7.066V8.7a1.058,1.058,0,0,1-.319.778,1.031,1.031,0,0,1-.753.319H1.633a1.058,1.058,0,0,1-.778-.319A1.06,1.06,0,0,1,.536,8.7ZM7.627.536v1.1H0V.536H1.913L2.449,0h2.73l.536.536Z" transform="translate(1810.186 198.102)" fill="#fff" />
                              </g>
                            </svg>
                          </div>
                          {/* <div onClick={() => { setIniticalValue(entry); setOpenForm(!openForm); }}>e</div> */}
                          <div style={{ width: '30px', float: 'left', cursor: 'pointer' }} onClick={() => { setOpen(true); setCredit(entry); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" id="eye" width={24} height={24} viewBox="0 0 24 24">
                              <path id="Trazado_138" data-name="Trazado 138" d="M24,21a3,3,0,1,1-3-3A3,3,0,0,1,24,21Z" transform="translate(-9 -9)" fill="none" stroke="#4a5568" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" />
                              <path id="Trazado_139" data-name="Trazado 139" d="M4.92,17A10,10,0,0,1,24,17,10,10,0,0,1,4.92,17Z" transform="translate(-2.46 -5)" fill="none" stroke="#4a5568" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" />
                              <path id="Trazado_140" data-name="Trazado 140" d="M0,0H24V24H0Z" fill="none" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              }
            </Col>
          )
        }


      </Row>
      {
        open && (<SidebarEarnCredit open={open} toggleSidebar={() => { setOpen(false); }} Credit={Credit} />)
      }

    </Card>
  );
};
